import { useAtomValue } from 'jotai';
import { ScopeProvider } from 'jotai-scope';
import { useTranslation } from 'react-i18next';
import { TEAM_RADAR_FILTER_SOURCE, SCOPE_CONTEXT_FILTER_KEYS } from '@/analytics/snowplow/filterTracking';
import { useTrackFilterChanges } from '@/analytics/snowplow/hooks/useTrackFilterChanges';
import { tableColumnEntitiesAtom } from '@/atoms/queries/tableColumns';
import { unwrappedSelectedTeamNameAtom } from '@/atoms/team/info';
import { PageTitle } from '@/components/head/PageTitle';
import { TeamLayoutWithFilters } from '@/components/layout/team/TeamLayoutWithFilters';
import { TeamRadar } from '@/components/team/radar/TeamRadar';
import { useEntityPageTitle } from '@/hooks/useEntityPageTitle';
import { useTableColumns } from '@/hooks/useTableColumns';

const SetTeamMetrics = () => {
  useTableColumns(['team_metric']);
  return null;
};

export const TeamRadarPage = () => {
  const { t } = useTranslation('navigation');
  const teamName = useAtomValue(unwrappedSelectedTeamNameAtom);
  const pageTitle = useEntityPageTitle(t('secondary.radar'), teamName);
  useTrackFilterChanges(SCOPE_CONTEXT_FILTER_KEYS, TEAM_RADAR_FILTER_SOURCE);

  return (
    <ScopeProvider atoms={[tableColumnEntitiesAtom]}>
      <PageTitle>{pageTitle}</PageTitle>
      <TeamLayoutWithFilters>
        <TeamRadar />
      </TeamLayoutWithFilters>
      <SetTeamMetrics />
    </ScopeProvider>
  );
};
